<template>
  <div class="container">
    <base-frame
      :breadcrumb="[
        {
          name: 'inspection',
          title: '验收单列表'
        },
        {
          name: 'inspectionInfo',
          title: '验收单详情'
        }
      ]"
      @btn-click="onBtnClick"
    >
    <div slot="info">
      <div class="info-container">
        <div class="info-item">
          <h4>验收单编码：{{purchaseInspection.code}}</h4>
          <div>验收员：{{purchaseInspection.createUserName}}</div>
          <div>复核员：{{purchaseInspection.reviewerName}}</div>
        </div>
        <div class="info-item">
          <h4>收货单编码：{{purchaseReceipt.code}}</h4>
          <div>收货员：{{purchaseReceipt.createUserName}}</div>
          <div>创建时间：{{purchaseReceipt.createTime}}</div>
          <!-- <div>仓库：{{purchaseReceipt.supplierInventory}}</div> -->
          <div>运输方式：{{purchaseReceipt.transportMode}}</div>
          <div v-if="purchaseReceipt.transportModeId === 4">承运方式：{{purchaseReceipt.carryModeName}}</div>
          <div v-if="purchaseReceipt.transportModeId === 4">承运单位：{{purchaseReceipt.carrier}}</div>
          <div>车牌号：{{purchaseReceipt.licensePlate}}</div>
          <div>起运时间：{{purchaseReceipt.transTimeStart}}</div>
          <div>到货时间：{{purchaseReceipt.transTimeEnd}}</div>
          <div>随货同行单：{{purchaseReceipt.travelNo}}</div>
        </div>
        <div class="info-item">
          <h4>采购订单号：{{purchaseOrder.code}}</h4>
          <div>创建时间：{{purchaseOrder.createTime}}</div>
          <div>供应商：{{purchaseOrder.supplierName}}</div>
          <div>成本类型：{{purchaseOrder.paymentName}}</div>
        </div>
        <div class="info-item">
          <h4>采购计划单号：{{purchasePlan.code}}</h4>
          <div>商品类型：{{purchasePlan.goodsTypeName}}</div>
          <div>来源：{{purchasePlan.typeName}}</div>
          <div>采购人：{{purchasePlan.createUserName}}</div>
          <div>创建时间：{{purchasePlan.createTime}}</div>
        </div>
        <div class="info-item">
          <h4>应付单号：{{payableCode}}</h4>
        </div>
      </div>
    </div>
    <div slot="content">
      <ApprovalFlow :workNo="workNo" class="steps-wrap" :finishHide="true"/>
      <lk-card title="商品详情">
        <div class="sum-wrap">
          <div class="title-amount">总商品数量</div>
          <div class="content-amount">{{inspectionGoodsNum}}</div>
          <div class="title-money">总金额（元）</div>
          <div class="content-money">&yen;{{inspectionAmount}}</div>
        </div>
        <lk-table border :columns='columns' :data='tableData'></lk-table>
      </lk-card>
      <lk-card title="其他信息" class="other-card">
        <lk-form :label-width='130' label-position="right">
          <lk-row class="reject-row" :gutter='16' style="margin-bottom:16px">
            <lk-col span="24">
              <lk-form-item label="拒收商品:">
                <lk-table border :data="rejectData" :columns="rejectColumn" class="rejectTable"/>
              </lk-form-item>
            </lk-col>
          </lk-row>
          <lk-row v-for="(item, index) in purchaseReceiptImgInfoList" :key="index">
            <lk-col span="10">
              <lk-form-item label="温度附件图:">
                <Uploader  v-model="item.temperatureImg"></Uploader>
              </lk-form-item>
            </lk-col>
            <lk-col span="2"></lk-col>
            <lk-col span="10">
              <lk-form-item label="温度图备注:">
                <span>{{item.imgComment}}</span>
              </lk-form-item>
            </lk-col>
          </lk-row>
        </lk-form>
      </lk-card>
    </div>
    </base-frame>
    <lk-modal
      v-model="logShow"
      title="操作日志"
      :footer-hide="true"
      on-cancel="onLogCancel"
    >
      <div v-for="(item, index) in LogItems" :key="index">
        <div v-if="item.purchasePlanModifiedHistory">
          <span>{{index+1}}.</span>
          <span v-if="item.purchasePlanModifiedHistory.content=='提交'">{{item.purchasePlanModifiedHistory.createTime}} 由 {{item.purchasePlanModifiedHistory.createUserName}} 提交</span>
          <span v-else>{{item.purchasePlanModifiedHistory.createTime}} 由 {{item.purchasePlanModifiedHistory.createUserName}} 修改，修改了 {{item.purchasePlanModifiedHistory.content}}，新值：{{item.purchasePlanModifiedHistory.newValue}}，旧值：{{item.purchasePlanModifiedHistory.oldValue}}</span>
        </div>
        <div  v-if="item.purchaseReviewRecordVo">
          <span>{{index+1}}.</span>
          <span>{{item.purchaseReviewRecordVo.operateTime}} 由 {{item.purchaseReviewRecordVo.operateUserName}} 审批，审批状态：{{item.purchaseReviewRecordVo.workStatus}}，审批意见：{{item.purchaseReviewRecordVo.idea}}</span>
        </div>
      </div>
    </lk-modal>
  </div>
</template>

<script>

import BaseFrame from '../../components/frame/NewBaseFrame.vue';
import purchase from '../../services/purchase';
import utils from '../../libs/utils';
import Uploader from '../../components/Uploader.vue';
import ApprovalFlow from '../../components/ApprovalFlow';

export default {
  name: 'inspectionInfo',
  components: {
    BaseFrame, Uploader, ApprovalFlow,
  },
  data() {
    return {
      inspectionGoodsNum: '',
      inspectionAmount: '',
      rejectData: [],
      rejectColumn: [
        {
          title: '通用名称',
          key: 'medicineInfoVoApprovedDrugNames',
        },
        {
          title: '医保编码',
          key: 'medicineInfoVoMedicalSerialCode',
        },
        {
          title: '商品编码',
          key: 'purchaseMedicineDrugSerialCode',
        },
        {
          title: '规格',
          key: 'medicineInfoVoSpecifications',
        },
        {
          title: '剂型',
          key: 'medicineInfoVoDosageFormString',
        },
        {
          title: '拒收数量',
          key: 'purchaseInspectionInfoRejectNum',
        },
        {
          title: '拒收原因',
          key: 'purchaseInspectionInfoRejectReason',
        },
      ],
      LogItems: [],
      logShow: false,
      workNo: '',
      paymentType: ['普通', '寄售'],
      purchaseReceiptImgInfoList: [],
      queryParams: {
        purchaseInspectionId: '',
      },
      purchasePlan: {
        code: '',
        goodsType: null,
      },
      purchaseOrder: {
        code: '',
        createUserName: '',
      },

      purchaseReceipt: {
        code: '',
        createUserName: '',
        transTimeStart: '',
        transTimeEnd: '',
      },
      purchaseInspection: {
        code: '',
        status: '',
        createUserName: '',
        createTime: '',
      },
      payableCode: '',
      columns: [
        {
          title: '行号',
          minWidth: 56,
          render: (h, { index }) => h('span', index + 1),
        },
        {
          title: '通用名称',
          key: 'medicineInfoVoApprovedDrugNames',
          tooltip: true,
          minWidth: 142,
        },
        {
          title: '医保编码',
          width: 200,
          tooltip: true,
          key: 'medicineInfoVoMedicalSerialCode',
        },
        {
          title: '商品编码',
          tooltip: true,
          key: 'purchaseMedicineDrugSerialCode',
          minWidth: 82,
        },
        {
          title: '批准文号',
          tooltip: true,
          key: 'medicineInfoVoApprovalCode',
          minWidth: 116,
        },
        {
          title: '规格',
          tooltip: true,
          key: 'medicineInfoVoSpecifications',
          minWidth: 130,
        },
        {
          title: '商品名称',
          tooltip: true,
          key: 'medicineInfoVoGoodsName',
          minWidth: 142,
        },
        {
          title: '验收合格数',
          tooltip: true,
          key: 'purchaseInspectionInfoPassNum',
          minWidth: 94,
        },
        {
          title: '验收结果',
          tooltip: true,
          key: 'purchaseInspectionInfoResult',
          minWidth: 82,
        },
        {
          title: '实收数量',
          tooltip: true,
          key: 'purchaseInspectionInfoPassNum',
          minWidth: 82,
        },
        {
          title: '实际含税单价',
          tooltip: true,
          key: 'purchaseInspectionInfoPriceBeforeTax',
          minWidth: 106,
        },
        {
          title: '批号',
          key: 'purchaseInspectionInfoGoodsBatchNum',
          tooltip: true,
          minWidth: 82,
        },
        {
          title: '生产日期',
          key: 'purchaseInspectionInfoProdDate',
          tooltip: true,
          minWidth: 96,
        },
        {
          title: '有效日期',
          key: 'purchaseInspectionInfoExpiryDate',
          tooltip: true,
          minWidth: 96,
        },
        {
          title: '追溯码',
          key: 'purchaseInspectionInfoTraceCode',
          tooltip: true,
          minWidth: 160,
        },
        {
          title: 'UDI码',
          key: 'purchaseInspectionInfoUdiCode',
          tooltip: true,
          minWidth: 160,
        },
        {
          title: '计划数量',
          tooltip: true,
          key: 'purchaseMedicineNum',
          minWidth: 82,
        },
        {
          title: '仓库',
          tooltip: true,
          key: 'purchaseInspectionInfoWareHouseName',
          minWidth: 94,
        },
        {
          title: '货位',
          tooltip: true,
          key: 'purchaseInspectionInfoLocationCode',
          minWidth: 94,
        },
        {
          title: '批次',
          tooltip: true,
          key: 'purchaseInspectionInfoGoodsBatchSeq',
          minWidth: 150,
        },
        {
          title: '拒收数量',
          tooltip: true,
          key: 'purchaseInspectionInfoRejectNum',
          minWidth: 82,
        },
        {
          title: '拒收原因',
          tooltip: true,
          key: 'purchaseInspectionInfoRejectReason',
          minWidth: 82,
        },
        {
          title: '起点温度',
          tooltip: true,
          key: 'purchaseReceiptInfoStartTemperature',
          minWidth: 82,
        },
        {
          title: '到店温度',
          tooltip: true,
          key: 'purchaseReceiptInfoEndTemperature',
          minWidth: 82,
        },
        {
          title: '储存条件',
          tooltip: true,
          key: 'medicineInfoVoStorageConditions',
          minWidth: 112,
        },
        {
          title: '剂型',
          tooltip: true,
          key: 'medicineInfoVoDosageFormString',
          minWidth: 116,
        },
        {
          title: '单位',
          tooltip: true,
          key: 'purchaseMedicineDrugMinimumPackagingUnit',
          minWidth: 60,
        },
        {
          title: '产地',
          tooltip: true,
          key: 'purchaseMedicineCountryOfOrigin',
          minWidth: 142,
        },
        {
          title: '生产企业',
          tooltip: true,
          key: 'medicineInfoVoManufacturer',
          minWidth: 142,
        },
        {
          title: '上市许可持有人',
          minWidth: 142,
          tooltip: true,
          key: 'medicineInfoVoMah',
        },
      ],
      tableData: [],
      page: 1,
      size: 10,
      count: 0,
      localtion: [],
      type: ['审核中', '废弃', '完成'],
    };
  },
  methods: {
    onBtnClick(name) {
      if (name === 'log') {
        this.onShowLog();
      }
    },
    onLogCancel() {
      this.logShow = false;
    },
    onShowLog() {
      this.logShow = true;
    },
    getLog() {
      const params = {
        purchasePlanId: this.$route.params.purchasePlanId,
      };
      this.$store.commit('setDisableLoading', true);
      purchase.planLog(params).then((res) => {
        // console.log(res);
        if (res.data.status === 200) {
          this.LogItems = res.data.data;
          this.LogItems.forEach((item) => {
            if (item.purchasePlanModifiedHistory) {
              item.purchasePlanModifiedHistory.createTime = utils.formatTime(item.purchasePlanModifiedHistory.createTime, 'YYYY/MM/DD HH:mm');
            }
            if (item.purchaseReviewRecordVo) {
              item.purchaseReviewRecordVo.operateTime = utils.formatTime(item.purchaseReviewRecordVo.operateTime, 'YYYY/MM/DD HH:mm');
            }
          });
        }
      });
    },
    getData() {
      this.queryParams.purchaseInspectionId = this.$route.params.purchaseInspectionId;
      const queryParams = Object.assign({}, this.queryParams);
      // console.log(queryParams);
      purchase.inspectionInfo(queryParams).then((res) => {
        if (res.data.status === 200) {
          this.tableData = [];
          this.inspectionAmount = res.data.data.inspectionAmount;
          this.inspectionGoodsNum = res.data.data.inspectionGoodsNum;
          if (res.data.data.purchaseInspection) {
            this.purchaseInspection.code = res.data.data.purchaseInspection.code;
            this.purchaseInspection.createUserName = res.data.data.purchaseInspection.createUserName;
            this.purchaseInspection.reviewerName = res.data.data.purchaseInspection.reviewerName;
          }
          if (res.data.data.purchaseReceipt) {
            this.purchaseReceipt.createTime = utils.formatTime(res.data.data.purchaseReceipt.createTime, 'YYYY/MM/DD HH:mm');
            this.purchaseReceipt.createUserName = res.data.data.purchaseReceipt.createUserName;
            this.purchaseReceipt.code = res.data.data.purchaseReceipt.code;
            this.purchaseReceipt.supplierInventory = res.data.data.purchaseReceipt.supplierInventory;
            this.purchaseReceipt.transportMode = res.data.data.purchaseReceipt.transportMode;
            this.purchaseReceipt.transportModeId = res.data.data.purchaseReceipt.transportModeId;
            this.purchaseReceipt.carryModeName = res.data.data.purchaseReceipt.carryModeName;
            this.purchaseReceipt.carrier = res.data.data.purchaseReceipt.carrier;
            this.purchaseReceipt.licensePlate = res.data.data.purchaseReceipt.licensePlate;
            this.purchaseReceipt.travelNo = res.data.data.purchaseReceipt.travelNo;
            if (res.data.data.purchaseReceipt.transTimeStart) {
              this.purchaseReceipt.transTimeStart = utils.formatTime(res.data.data.purchaseReceipt.transTimeStart, 'YYYY/MM/DD HH:mm');
            }
            if (res.data.data.purchaseReceipt.transTimeEnd) {
              this.purchaseReceipt.transTimeEnd = utils.formatTime(res.data.data.purchaseReceipt.transTimeEnd, 'YYYY/MM/DD HH:mm');
            }
          }
          if (res.data.data.purchaseOrder) {
            this.purchaseOrder.code = res.data.data.purchaseOrder.code;
            this.purchaseOrder.supplierName = res.data.data.purchaseOrder.supplierName;
            this.purchaseOrder.paymentName = this.paymentType[res.data.data.purchaseOrder.payment - 1];
            this.purchaseOrder.createTime = utils.formatTime(res.data.data.purchaseOrder.createTime, 'YYYY/MM/DD HH:mm');
          }
          if (res.data.data.purchasePlan) {
            this.purchasePlan.code = res.data.data.purchasePlan.code;
            this.purchasePlan.createUserName = res.data.data.purchasePlan.createUserName;
            this.purchasePlan.createTime = utils.formatTime(res.data.data.purchasePlan.createTime, 'YYYY/MM/DD HH:mm');
            this.purchasePlan.goodsTypeName = res.data.data.purchasePlan.goodsTypeName;
            this.purchasePlan.goodsType = res.data.data.purchasePlan.goodsType;
            this.purchasePlan.typeName = res.data.data.purchasePlan.typeName;
          }

          res.data.data.purchaseMedicineInfoVoList.forEach((item) => {
            const result = {};
            utils.exchangeTable(item, result);
            result.purchaseInspectionInfoExpiryDate = utils.formatTime(result.purchaseInspectionInfoExpiryDate, 'YYYY/MM/DD');
            result.purchaseInspectionInfoProdDate = utils.formatTime(result.purchaseInspectionInfoProdDate, 'YYYY/MM/DD');
            console.log(result);
            this.tableData.push(result);
          });
          if (res.data.data.purchaseInspection && res.data.data.purchaseInspection.workNo) {
            this.workNo = res.data.data.purchaseInspection.workNo;
          }
          if (res.data.data.purchaseReceiptImgInfoList) {
            this.purchaseReceiptImgInfoList = res.data.data.purchaseReceiptImgInfoList;
          }
          res.data.data.purchaseRejectionInfoVoList.forEach((item) => {
            const result = {};
            utils.exchangeTable(item, result);
            this.rejectData.push(result);
          });
          this.payableCode = res.data.data.payableCode || '';
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    handlePage(page) {
      this.page = page;
      this.getData();
    },
    handlePageSize(size) {
      this.size = size;
      this.getData();
    },
  },
  watch: {
    'purchasePlan.goodsType': function goodsTypeHandler() {
      if (this.purchasePlan.goodsType === 2) {
        this.columns.splice(3, 1, {
          title: '注册证号/备案号',
          minWidth: 124,
          tooltip: true,
          key: 'medicineInfoVoApprovalCode',
        });
      } else {
        this.columns.splice(3, 1, {
          title: '批准文号',
          key: 'medicineInfoVoApprovalCode',
          tooltip: true,
          minWidth: 116,
        });
      }
    },
  },
  created() {
    this.getData();
    // this.getLog()
  },
};
</script>
<style lang="less" scoped>
.temp-img{
  height: 80px;
  width: 80px;
}
.other-card{
  margin-top: 30px;
}
.reject-row{
  margin-bottom: 40px;
}
.steps-wrap{
  padding-top: 30px;
  padding-bottom: 30px;
}
</style>
